import { render } from "./ChangeTeamRoleDialog.vue?vue&type=template&id=d61f3db8"
import script from "./ChangeTeamRoleDialog.vue?vue&type=script&lang=js"
export * from "./ChangeTeamRoleDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__